var listKeys = [
    'alertDoNotDisturb',
    'warningCaution',
    'warningAway',
    'positivePrimary',
    'positiveSecondary',
    'complete'
];
export var getStatusColor = function (propsColor, theme) {
    var normalizedColors = listKeys.map(function (s) { return s.toLowerCase(); });
    var foundIndex = normalizedColors.findIndex(function (s) { var _a; return s.toLowerCase() === ((_a = mapDeprecatedColorNames(propsColor)) === null || _a === void 0 ? void 0 : _a.toLowerCase()); });
    if (!propsColor) {
        return 'transparent';
    }
    else if (foundIndex !== -1) {
        return theme.semanticColors[listKeys[foundIndex]];
    }
    else {
        return propsColor;
    }
};
var mapDeprecatedColorNames = function (name) {
    if (name === 'Positive1')
        return 'positivePrimary';
    else if (name === 'Positive2')
        return 'positiveSecondary';
    else
        return name;
};
//# sourceMappingURL=DataGridColumnStatus.utilities.js.map